import React from 'react'

/**
 * 带圈数字 - ①②③...
 * @param param - 参数
 * @param param.style - CSS样式
 * @param param.number - 圈内数字
 * @param param.size - 大小【默认18】
 * @returns React.ReactNode
 */
export const CircledNumber: React.FC<{
  number: number
  size?: number | string
  fontSize?: number | string
  color?: string
  style?: React.CSSProperties
}> = ({ style, number, size = 18, fontSize = 12, color }) => {
  const sizeStr = typeof size === 'number' ? `${size || 18}px` : size
  const fontSizeStr =
    typeof fontSize === 'number' ? `${fontSize || 12}px` : fontSize
  return (
    <div
      style={{
        ...style,
        borderRadius: '50%',
        border: '1px solid #718999',
        borderColor: color || '#718999',
        color: color || '#718999',
        width: sizeStr,
        height: sizeStr,
        lineHeight: sizeStr,
        fontSize: fontSizeStr,
        textAlign: 'center',
        flexShrink: 0,
        transform: 'scale(0.8)',
        fontWeight: 500,
      }}
    >
      {number}
    </div>
  )
}
